

<app-website-header></app-website-header>

<div class="container-fluid">

    <section class="about">
        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 24px"></div>
        </div>


        <div class="row">
            <div class="col-sm-1"></div>

            <div class="about-image">
                <p style="object-fit: contain;
            font-family: Raleway;
            font-size: 45px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.33;
            letter-spacing: 0.32px;
            text-align: left;
            color: #ff6d11;">Pricing</p>
                <p style="margin-top:-33px;"><img src="assets/section-images/Path 336.png"> </p>
            </div>

            <div class="col-sm-1"></div>
        </div>

        <div class="row">
            <div class="col-sm-1"></div>

            <div class="about-image">
                <p style="font-family: Raleway;
                font-size: 36px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.17;
                letter-spacing: normal;
                text-align: left;
                color: #ff6d11">Filing Fees Details</p>
            </div>

            <div class="col-sm-1"></div>
        </div>

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 24px"></div>
        </div>

        <div class="container">
            <table class="table table-dark" style="width: 110%;margin-left: -7%;">
                <thead style="text-align: justify;">
                    <tr style="background-color: #F16821;">
                        <th>Particulars</th>
                        <th>Federal</th>
                        <th>Each State</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-background">
                        <td>Federal - Standard Tax Return (Form 1040)</td>
                        <td>$19.99</td>
                        <td>$29.99 </td>
                    </tr>
                    <tr class="table-background">
                        <td>Federal - Itemized Tax Return (Schedule A)</td>
                        <td>$99.99 </td>
                        <td>$29.99 </td>
                    </tr>
                    <tr class="table-background">
                        <td>Federal - Planning (Form 1040) If Eligible</td>
                        <td>$79.99 </td>
                        <td>$29.99 </td>
                    </tr>
                    <tr class="table-background">
                        <td>Federal – ITIN (Guidance & Paper Filing)</td>
                        <td>$99.99 </td>
                        <td>$29.99 </td>
                    </tr>
                    <tr class="table-background">
                        <td>Federal – ITIN (Spouse Election & Paper Filing)</td>
                        <td>$110 </td>
                        <td>$29.99 </td>
                    </tr>
                    <tr class="table-background">
                        <td>Federal – Schedule C, E & 1099 Misc</td>
                        <td>$99.99 </td>
                        <td>$29.99 </td>
                    </tr>
                    <tr class="table-background">
                        <td>Federal–Non Resident Tax Return (US India Tax Treaty)</td>
                        <td>$79.99 </td>
                        <td>$29.99 </td>
                    </tr>
                    <tr class="table-background">
                        <td>City Tax Returns</td>
                        <td>$9.99 </td>
                        <td style="color: white; font-weight: bolder;"> -</td>
                    </tr>
                    <tr class="table-background">
                        <td>For Each Additional State</td>
                        <td style="color: white; font-weight: bolder;">-</td>
                        <td>$25 </td>
                    </tr>
                    <tr class="table-background">
                        <td>FBAR & FATCA</td>
                        <td style="color: white; font-weight: bolder;">-</td>
                        <td>$9.99 </td>
                    </tr>
                    <tr class="table-background">
                        <td>Form 1116</td>
                        <td style="color: white; font-weight: bolder;">-</td>
                        <td>$19.99 </td>
                    </tr>
                    <tr class="table-background">
                        <td>FICA Taxes If Eligible</td>
                        <td>No Cost</td>
                        <td style="color: white; font-weight: bolder;">-</td>
                    </tr>
                    <tr class="table-background">
                        <td>Extension Filing</td>
                        <td>No Cost</td>
                        <td style="color: white; font-weight: bolder;">-</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 40px"></div>
        </div>

        <div class="row">
            <div class="col-sm-1"></div>
            <div class="col-sm">
                <p style="font-family: Raleway;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.19;
            letter-spacing: 0.13px;
            text-align: left;
            color: #000000;">Evolv Tax Filing will be happy to provide you the entire accurate tax estimates of
                    your tax returns absolutely free of cost, online portals or other tax consultants would just
                    give you a final figure of your tax refund or owe amount, but instead we provide you the entire
                    tax estimates which can show you the entire details about your exemptions, deductions, credits
                    line by line on the tax returns. It means we provide you the entire tax estimates without any
                    fees.

                    <br><br> Evolv Tax Filing is happy to announce a new referral policy for all the clients across
                    United States.As soon as your referred clients avail our services and make payment, you will be
                    paid immediately an amount of $10 as a referral bonus.</p>
            </div>
            <div class="col-sm-1"></div>
        </div>

        <div class="row">
            <!-- <div class="col" style="height: 1px;"></div> -->
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 50px"></div>
            <!-- <div class="col-lg" style="height: 150px;"></div> -->
        </div>

        <div class="row">
            <div class="col-sm-1"></div>

            <div class="col-sm-5">
                <p class="need-help">NEED HELP?</p> <br>
                <p class="need-content">
                    Contact our customer support team if you have any further questions. We are here to help you
                    out.
                </p> <br>

                <a href="tel:+1(888)690-5754">
                    <button class="btn  btn-sm Number" id="right" style="width: 250px;
                                height: 50px;
                                object-fit: contain;
                                border-radius: 25px;
                                background-color: #ff6d11;
                                color: white;">
                    +1 (888) 690 - 5754 &nbsp;
                </button>
                </a>
            </div>

            <div class="col-sm-5">
                <img src="assets/section-images/Group 1364.png">
            </div>

            <div class="col-sm-1"></div>
        </div>

        <div class="row">
            <!-- <div class="col" style="height: 1px;"></div> -->
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 65px"></div>
            <!-- <div class="col-lg" style="height: 150px;"></div> -->
        </div>
    </section>

</div>


<app-website-footer></app-website-footer>